module.exports = __webpack_public_path__ + "static/media/Cisco_logo_blue.svg.0669bdc7.png";